// Short Spanish spec values for the series spec bars, read from the bicicletas table.
// cuadro_material starts with the wheel size, e.g. '29/27.5" Alloy 6061, boost, 150 mm'.
const NONE = '—';
const firstPart = (text) => (text ? String(text).split(',')[0].trim() : '');

export const bikeSpecs = {
    recorrido: (bike) => (bike?.recorrido_mm > 0 ? `${bike.recorrido_mm} mm` : 'Rígida'),
    rueda: (bike) => {
        const match = String(bike?.cuadro_material || '').match(/^\s*([\d.]+(?:\/[\d.]+)?)\s*"/);
        return match ? `${match[1].replace('/', '" / ')}"` : NONE;
    },
    motor: (bike) => firstPart(bike?.motor_modelo) || NONE,
    bateria: (bike) => (bike?.bateria_wh ? `${bike.bateria_wh} Wh` : NONE),
    cuadro: (bike) => {
        const text = String(bike?.cuadro_material || '');
        if (/carbon/i.test(text)) return 'Carbono';
        if (/alloy|alu/i.test(text)) return 'Aluminio';
        return NONE;
    },
    transmision: (bike) => firstPart(bike?.transmision_modelo) || NONE,
    frenos: (bike) => {
        const text = String(bike?.frenos_modelo || '');
        if (/v-brake/i.test(text)) return 'V-Brake';
        if (/disc/i.test(text)) return 'Disco hidráulico';
        return firstPart(text) || NONE;
    },
    peso: (bike) => (bike?.peso_kg ? `${bike.peso_kg} kg` : NONE)
};
